import {BaseModel} from "../base-model";
import {TermsUtils} from "../../utils/terms-utils";
import {IOC} from "../../ioc";
import {Type} from "../../type";
import {computed} from "mobx";
import {SITE_DOMAINS} from "../../../core/consts";

export class BaseRouteMetaDataModel extends BaseModel {
  ioc: IOC;

  constructor(ioc: IOC) {
    super();

    this.ioc = ioc;
  }

  @computed isPopulated(): Boolean {
    return true;
  }

  get termsUtils(): TermsUtils {
    return this.resolve(TermsUtils);
  }

  get pageTitle(): String { return null }

  get description(): String { return null }

  get canonicalUrl(): String { return null }

  get xDefaultLink(): String { return null }

  get alternateLinks(): Array { return null }

  resolve(type: Type): Type {
    return this.ioc.getInstance(type);
  }

  get isNoIndex(): Boolean {
    return false;
  }

  @computed get shouldRenderHrefModels() {
    const homepageValid = window.location.href.split('?')[0] === `${SITE_DOMAINS.full}/` || window.location.href.split('?')[0] === `${SITE_DOMAINS.full}/`
    const otherPagesValid = this.canonicalUrl === window.location.href.split('#')[0] || this.canonicalUrl === window.location.href.split('?')[0];

    return homepageValid || otherPagesValid;
  }
}
